<template src="./template.html"></template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: { item: Object },
  computed: {
    ...mapState('settings', [
      'settings',
      'pendingSettings',
    ]),
    ...mapState('summary', [ 'coinPacksOnly' ]),
    isVirtualCurrency() {
      return !this.pendingSettings &&
             this.settings.active_features &&
             this.settings.active_features.use_virtual_currency &&
             !this.coinPacksOnly
    },
  },
  methods: {
    ...mapActions('summary', [ 'removeItem' ]),
    remove(e, item) {
      e.preventDefault()
      this.removeItem(item.id).then(() => {
        /* eslint-disable no-undef */
        if (typeof $.updateBonusSldrInCheckout === 'function') {
          $.updateBonusSldrInCheckout()
        }
        /* eslint-enable no-undef */
      })
    },
  },
}
</script>
